// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'a9143eef-97ff-4fd0-a5b6-d930bf6d70c7',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '3d7ef2f2-266c-4deb-965a-03a49e0d7870',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a9143eef-97ff-4fd0-a5b6-d930bf6d70c7'
    },
    {
      id: '75a76145-db25-442f-8cf8-db54fa763720',
      type: 'Sprite',
      name: 'tutorialImage',
      className: '',
      x: 0,
      y: 35,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Tutorial_Image',
      parent: '3d7ef2f2-266c-4deb-965a-03a49e0d7870'
    },
    {
      id: '3a3b56ad-4f9e-4665-80f3-2e59402364d8',
      type: 'Text',
      name: 'text1',
      className: '',
      x: -160,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Beat levels without losing!',
      localize: true,
      maxWidth: 250,
      maxHeight: 119,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x0035e5',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 350,
        breakWords: false,
        lineHeight: 30,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3d7ef2f2-266c-4deb-965a-03a49e0d7870'
    },
    {
      id: '0a865ff3-2418-4d8e-84fd-0f9d6be8f408',
      type: 'Text',
      name: 'text2',
      className: '',
      x: 160,
      y: 206,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Reach streak milestones',
      localize: true,
      maxWidth: 250,
      maxHeight: 196,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x0035e5',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 320,
        breakWords: false,
        lineHeight: 30,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3d7ef2f2-266c-4deb-965a-03a49e0d7870'
    },
    {
      id: '5a0aca57-1bfd-4e25-beac-e9540eb6ad56',
      type: 'Text',
      name: 'text3',
      className: '',
      x: -160,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Claim rewards',
      localize: true,
      maxWidth: 250,
      maxHeight: 93,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x0035e5',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 396,
        breakWords: false,
        lineHeight: 30,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3d7ef2f2-266c-4deb-965a-03a49e0d7870'
    },
    {
      id: '8c301047-7b96-45aa-8da6-d4439765a8bc',
      type: 'Text',
      name: 'continueButton',
      className: '',
      x: 0,
      y: 555,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -4000,
        y: -4000,
        width: 8000,
        height: 8000
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3d7ef2f2-266c-4deb-965a-03a49e0d7870'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '2.0.0',
  animations: [
    {
      id: 'fab3828b-2c46-4b7f-b777-e3ba88733633',
      name: 'Appear',
      playingSpeed: 1,
      totalDuration: 1200,
      blocks: [
        {
          id: '1f9b6b27-8af4-4c35-86b3-9ece0473e182',
          type: 'Setter',
          name: 'image2Scale',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'image2',
          disabled: false
        },
        {
          id: '2c7b6c01-e63b-4e30-b989-3736bd2d41ee',
          type: 'Setter',
          name: 'image3Scale',
          track: 6,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'image3',
          disabled: false
        },
        {
          id: '48c7b827-6422-497f-812f-4a7cf9f56d7c',
          type: 'Setter',
          name: 'arrow1Scale',
          track: 8,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            angle: -50
          },
          startAt: 0,
          sourceName: 'arrow1',
          disabled: false
        },
        {
          id: 'e335989f-5ffb-4419-aa03-324aa4efd63f',
          type: 'Setter',
          name: 'arrow2Scale',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            angle: 50
          },
          startAt: 0,
          sourceName: 'arrow2',
          disabled: false
        },
        {
          id: 'd0f0e860-2cf0-40dc-978b-a2fd37dbc4c3',
          type: 'Setter',
          name: 'text1Alpha',
          track: 14,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'text1',
          disabled: false
        },
        {
          id: '3a54147a-3c53-446a-8fb5-acc685abbf4b',
          type: 'Setter',
          name: 'text2Alpha',
          track: 13,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'text2',
          disabled: false
        },
        {
          id: '221edb78-7b0c-4cba-9407-0d23ce42f15f',
          type: 'Setter',
          name: 'text2Alpha_copy',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'text3',
          disabled: false
        },
        {
          id: '1b6be352-6008-4fd9-8227-5263211f109c',
          type: 'Setter',
          name: 'continueAlpha',
          track: 17,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'continueButton',
          disabled: false
        },
        {
          id: 'f5300919-7ff0-4eb8-9bda-62839d273ee2',
          type: 'Setter',
          name: 'image1Scale',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 1,
          sourceName: 'image1',
          disabled: false
        },
        {
          id: '9dc72d14-f111-4008-bbdc-7f67d2d9913e',
          type: 'Tween',
          name: 'image1Scale_1',
          duration: 250,
          track: 2,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 20,
          sourceName: 'image1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '785d2a85-dd9e-45f6-aa90-f7bc61370877',
          type: 'Tween',
          name: 'text1Alpha_1',
          duration: 400,
          track: 14,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'text1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0f7d6bd2-c7a1-4c52-811c-9c4b99235e65',
          type: 'Tween',
          name: 'image2Scale_1',
          duration: 250,
          track: 4,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 100,
          sourceName: 'image2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '26895b63-2124-4730-8c24-61e1f250cb88',
          type: 'Tween',
          name: 'text2Alpha_1',
          duration: 400,
          track: 13,
          target: {
            alpha: 1
          },
          startAt: 180,
          sourceName: 'text2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f4ceabbf-ff95-4ae3-b2a8-d63ced9ffcc0',
          type: 'Tween',
          name: 'image3Scale_1',
          duration: 250,
          track: 6,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            }
          },
          startAt: 180,
          sourceName: 'image3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c4f742eb-72b1-447d-904f-2d62888e78ef',
          type: 'Tween',
          name: 'arrow1ScaleRotation',
          duration: 250,
          track: 8,
          target: {
            scale: {
              x: 1.1,
              y: 1.1
            },
            angle: 0
          },
          startAt: 200,
          sourceName: 'arrow1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'dfc5c1cd-ffdb-44d6-a0cb-7a1147fbd47e',
          type: 'Tween',
          name: 'text3Alpha',
          duration: 400,
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 260,
          sourceName: 'text3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f047017c-b2f6-4439-a1a6-cc56d5dcceb3',
          type: 'Tween',
          name: 'image1Scale_2',
          duration: 150,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 270,
          sourceName: 'image1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b89bd0c1-c51e-4c74-b075-902fdf1ddc63',
          type: 'Tween',
          name: 'arrow2ScaleRotation',
          duration: 250,
          track: 10,
          target: {
            scale: {
              x: -1.1,
              y: 1.1
            },
            angle: 0
          },
          startAt: 320,
          sourceName: 'arrow2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '973fbbcf-0f18-4e02-839e-b1e17fa4b1c0',
          type: 'Tween',
          name: 'image2Scale_2',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 350,
          sourceName: 'image2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '94ea1e32-16b3-4f47-ba39-3bff805cfee0',
          type: 'Tween',
          name: 'image3Scale_2',
          duration: 150,
          track: 6,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 430,
          sourceName: 'image3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ee395034-f930-444f-a519-97e6a281abe1',
          type: 'Tween',
          name: 'arrow1ScaleRotation_1',
          duration: 150,
          track: 8,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 450,
          sourceName: 'arrow1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0829e5a0-af22-4a1d-a142-cb40ed9f7fcd',
          type: 'Tween',
          name: 'arrow2ScaleRotation_1',
          duration: 150,
          track: 10,
          target: {
            scale: {
              x: -1,
              y: 1
            },
            angle: 0
          },
          startAt: 570,
          sourceName: 'arrow2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'dbf71d90-9315-4252-8488-d093ee067276',
          type: 'Tween',
          name: 'continueAlpha_1',
          duration: 600,
          track: 17,
          target: {
            alpha: 1
          },
          startAt: 600,
          sourceName: 'continueButton',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class WinStreakTutorialPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  tutorialImage!: Sprite;
  text1!: Text;
  text2!: Text;
  text3!: Text;
  continueButton!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appear {
  Layout: {
    image2: object;
    image3: object;
    arrow1: object;
    arrow2: object;
    text1: object;
    text2: object;
    text3: object;
    continueButton: object;
    image1: object;
  };

  BlockTypeByName: {
    image2Scale: object;
    image3Scale: object;
    arrow1Scale: object;
    arrow2Scale: object;
    text1Alpha: object;
    text2Alpha: object;
    text2Alpha_copy: object;
    continueAlpha: object;
    image1Scale: object;
    image1Scale_1: object;
    text1Alpha_1: object;
    image2Scale_1: object;
    text2Alpha_1: object;
    image3Scale_1: object;
    arrow1ScaleRotation: object;
    text3Alpha: object;
    image1Scale_2: object;
    arrow2ScaleRotation: object;
    image2Scale_2: object;
    image3Scale_2: object;
    arrow1ScaleRotation_1: object;
    arrow2ScaleRotation_1: object;
    continueAlpha_1: object;
  };

  flowData = raw.animations[0];
}
